import { Language } from "@is/types";

/**
 * The languages the app offers under Language & country, and the native name
 * shown for each.
 *
 * This list used to come from an external translation service through
 * `GET api/instore/languages/list`. That service is retired, so the app now owns
 * the list: a language is selectable exactly when this file names it and
 * `src/i18n/translations/<code>.json` exists for it. `config.test.ts` asserts
 * those two sets match in both directions, so adding a catalog without adding it
 * here (or the reverse) fails the build rather than shipping a language that
 * renders in English.
 *
 * The names are the native ones the retired endpoint returned (.NET
 * `CultureInfo.NativeName`, i.e. CLDR), spelled out rather than derived from
 * `Intl.DisplayNames` so the labels are reviewable here and do not depend on the
 * browser's locale data.
 *
 * Ordered alphabetically by English language name, which is the order the picker
 * has always shown.
 */
export const SUPPORTED_LANGUAGE_NAMES: Record<string, string> = {
  hr: "hrvatski",
  cs: "čeština",
  da: "dansk",
  nl: "Nederlands",
  en: "English",
  fi: "suomi",
  fr: "français",
  de: "Deutsch",
  it: "italiano",
  pl: "polski",
  pt: "português",
  ro: "română",
  sl: "slovenščina",
  es: "español",
  sv: "svenska",
};

export const SUPPORTED_LANGUAGES: Language[] = Object.entries(
  SUPPORTED_LANGUAGE_NAMES
).map(([code, name]) => ({ code, name }));
